<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card flat>
        <v-expansion-panel-content class="mt-4">
          <div class="py-0 my-0">
            <div class="d-flex align-center">
              <div class="rowinfo">
                <v-btn
                  class="flex contentinfo"
                  color="success"
                  outlined
                  @click="manualDialog = true"
                >
                  <v-icon class="me-1" small>mdi-plus</v-icon>
                  افزودن ویدئو
                </v-btn>
                <help-info
                  :element-name="`${serviceName}-${componentName}-data-addvideo`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  label="افزودن ویدئو"
                />
              </div>
            </div>

            <custom-popup
              id="gallery"
              v-model="manualDialog"
              :cons="{ title: 'افزودن ویدیو' }"
              hide-confirm
              max-width="500"
            >
              <v-card class="p-8">
                <div class="rowinfo">
                  <v-text-field
                    v-model="manualVideo.title"
                    class="my-2 contentinfo"
                    dense
                    hide-details
                    label="عنوان"
                    outlined
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-manualVideo-title`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    label="عنوان"
                  />
                </div>
                <div class="rowinfo">
                  <v-text-field
                    v-model="manualVideo.url"
                    class="my-2 contentinfo"
                    dense
                    hide-details
                    label="آدرس ویدیو"
                    outlined
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-manualVideo-url`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    label="آدرس ویدیو"
                  />
                </div>

                <!--    todo:// salam bache ha inja 1 validate bara link bezarid please 😢            -->
                <div class="rowinfo">
                  <v-text-field
                    v-model="manualVideo.link"
                    class="my-2 contentinfo"
                    dense
                    hide-details
                    label="لینک"
                    outlined
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-manualVideo-link`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    label="لینک"
                  />
                </div>
                <div class="rowinfo">
                  <v-textarea
                    v-model="manualVideo.description"
                    class="my-2 contentinfo"
                    dense
                    hide-details
                    label="توضیحات"
                    maxLength="250"
                    outlined
                    rows="5"
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-manualVideo-link`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    label="توضیحات"
                  />
                </div>

                <v-card-actions>
                  <div class="rowinfo">
                    <v-btn
                      class="btn-sub ms-auto px-8"
                      color="green lighten-3"
                      @click="addImageManual(gallery)"
                    >
                      افزودن
                    </v-btn>
                    <help-info
                      :element-name="`${serviceName}-${componentName}-data-addImageManual`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      label="افزودن"
                    />
                  </div>
                </v-card-actions>
              </v-card>
            </custom-popup>

            <custom-popup
              id="gallery"
              v-model="editDialog"
              :cons="{ title: 'ویرایش ویدیو' }"
              max-width="500"
            >
              <v-card class="p-8">
                <div class="rowinfo">
                  <v-text-field
                    v-model="selectedVideo.title"
                    class="my-2 contentinfo"
                    dense
                    hide-details
                    label="عنوان"
                    outlined
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-selectedVideo-title`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    label="عنوان"
                  />
                </div>

                <!--    todo:// salam bache ha inja 1 validate bara link bezarid please 😢            -->
                <div class="rowinfo">
                  <v-text-field
                    v-model="selectedVideo.link"
                    class="my-2 contentinfo"
                    dense
                    hide-details
                    label="لینک"
                    outlined
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-selectedVideo-link`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    label="لینک"
                  />
                </div>
                <div class="rowinfo">
                  <v-textarea
                    v-model="selectedVideo.description"
                    class="my-2 contentinfo"
                    dense
                    hide-details
                    label="توضیحات"
                    maxLength="250"
                    outlined
                    rows="5"
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-selectedVideo-link`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    label="توضیحات"
                  />
                </div>
              </v-card>
            </custom-popup>

            <v-row no-gutters>
              <v-col
                v-for="(video, index) in gallery.videos"
                :key="index"
                class="align-center p-2 position-relative"
                cols="12"
              >
                <div class="border rounded" @click="selectVideo(video)">
                  <div class="rowinfo">
                    <v-btn
                      class="float-end zindex-5 p-0 ms-auto my-auto"
                      icon
                      small
                      @click.stop="deleteSelectedImage(gallery, video)"
                    >
                      <v-icon style="color: #999 !important">mdi-delete</v-icon>
                    </v-btn>
                    <help-info
                      :element-name="`${serviceName}-${componentName}-selectedVideo-selectVideo`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      label="انتخاب ویدنو"
                    />
                  </div>

                  <v-card
                    class="px-2 text-center d-flex flex-column align-center"
                    flat
                  >
                    <div class="rowinfo">
                      <v-btn
                        :disabled="gallery.videos.indexOf(video) === 0"
                        icon
                        @click.stop="moveUp(gallery, video)"
                      >
                        <v-icon v-if="gallery.videos.indexOf(video) !== 0"
                          >mdi-chevron-up</v-icon
                        >
                      </v-btn>
                      <help-info
                        :element-name="`${serviceName}-${componentName}-selectedVideo-gallery`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        label="ویدنو"
                      />
                    </div>

                    <iframe :src="video.url"></iframe>
                    <div class="rowinfo">
                      <v-btn
                        :disabled="
                          gallery.videos.indexOf(video) ===
                          gallery.videos.length - 1
                        "
                        icon
                        @click.stop="moveDown(gallery, video)"
                      >
                        <v-icon
                          v-if="
                            gallery.videos.indexOf(video) !==
                            gallery.videos.length - 1
                          "
                          >mdi-chevron-down</v-icon
                        >
                      </v-btn>
                      <help-info
                        :element-name="`${serviceName}-${componentName}-videos-gallery`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        label="ویدنو"
                      />
                    </div>
                  </v-card>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-expansion-panel-content>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import HelpInfo from "../../pages/qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../pages/qrland/components/helpAcordion/HelpInfoWrapper.vue";
export default {
  name: "VideoGallery",

  props: {
    value: Object,
    data: {
      type: Object,
      require: true,
    },
  },
  components: {
    HelpInfo,
    HelpInfoWrapper,
  },
  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "videoGallerySingle",
      manualDialog: false,
      editDialog: false,
      url: process.env.VUE_APP_ROBOT,
      manualVideo: {
        title: "",
        url: "",
        description: "",
        link: "",
      },
      gallery: {
        name: "گالری",
        videos: [],
      },
      selectedVideo: {},
      editGalleryName: -1,
    };
  },

  mounted() {
    this.$root.$on("clearDefaultData", this.clearDefaults);

    if (this.value) this.gallery = this.value;
  },

  watch: {
    gallery: {
      deep: true,
      handler(value) {
        // this.data['video_single'] = value;
        this.$emit("input", value);
      },
    },
  },

  methods: {
    moveUp(gallery, image) {
      let imageIndex = gallery.videos.indexOf(image);
      let previousIndex = imageIndex - 1;
      let tempPreviousImage = { ...gallery.videos[previousIndex] };
      let tempCurrentImage = { ...image };

      gallery.videos[imageIndex] = tempPreviousImage;
      gallery.videos[previousIndex] = tempCurrentImage;

      this.$forceUpdate();

      let arr = this.gallery;
      this.gallery = null;
      this.$nextTick(() => {
        this.gallery = arr;
      });
      // this.data['video_single'] = this.gallery;
      // this.$emit('input', this.gallery)
    },
    moveDown(gallery, image) {
      let imageIndex = gallery.videos.indexOf(image);
      let nextIndex = imageIndex + 1;
      let tempPreviousImage = { ...gallery.videos[nextIndex] };
      let tempCurrentImage = { ...image };

      gallery.videos[imageIndex] = tempPreviousImage;
      gallery.videos[nextIndex] = tempCurrentImage;

      this.$forceUpdate();

      let arr = this.gallery;
      this.gallery = null;
      this.$nextTick(() => {
        this.gallery = arr;
      });
      // this.data['video_single'] = this.gallery;
      // this.$emit('input', this.gallery)
    },
    deleteSelectedImage(gallery, image) {
      gallery.videos.splice(gallery.videos.indexOf(image), 1);
    },
    addImageManual(gallery) {
      let reg = new RegExp(/<iframe.*src="(.*?)".*>/, "gms");

      this.manualVideo.url =
        reg.exec(this.manualVideo.url)?.[1] ?? this.manualVideo.url;

      gallery.videos.push(this.manualVideo);

      this.manualDialog = false;

      this.manualVideo = {
        title: "",
        url: "",
        description: "",
        link: "",
      };
    },
    selectVideo(image) {
      this.selectedVideo = image;
      this.editDialog = true;
    },

    clearDefaults() {
      this.manualVideo = {
        title: "",
        url: "",
        description: "",
        link: "",
      };
      this.gallery = {
        name: "گالری",
        videos: [],
      };
      this.selectedVideo = {};
      this.editGalleryName = -1;
    },
  },
};
</script>

<style scoped></style>
